export default "__VITE_ASSET__CSa6D_ud__"